module.exports = __webpack_public_path__ + "static/media/RENTABILIDAD_F1.7eed540f.svg";